<template>
  <div class="july2022 text-NotoSansLight pt-6 md:pt-10">
    <div class="fixed-btn fixed z-50 hidden xl:block">
      <a class="cursor-pointer block px-3"><img src="~@/assets/images/202207/menu-off_01.png" class="object-contain"></a>
      <a class="hover-item cursor-pointer block px-3" @click="toTop(0)">
        <img src="~@/assets/images/202207/menu-off_02.png" class="off object-contain">
        <img src="~@/assets/images/202207/menu-on_02.png" class="on object-contain">
      </a>
      <a class="hover-item cursor-pointer block px-3" @click="toTop(1)">
        <img src="~@/assets/images/202207/menu-off_03.png" class="off object-contain">
        <img src="~@/assets/images/202207/menu-on_03.png" class="on object-contain">
        </a>
      <a class="hover-item cursor-pointer block px-3" @click="toTop(2)">
        <img src="~@/assets/images/202207/menu-off_04.png" class="off object-contain">
        <img src="~@/assets/images/202207/menu-on_04.png" class="on object-contain">
      </a>
      <a class="hover-item cursor-pointer block px-3" @click="toTop(3)">
        <img src="~@/assets/images/202207/menu-off_05.png" class="off object-contain">
        <img src="~@/assets/images/202207/menu-on_05.png" class="on object-contain">
      </a>
    </div>
    <div class="py-5 w-full header"></div>
    <section class="banner pt-3 md:pt-6 px-2 mb-6">
      <div class="flex max-w-6xl mx-auto z-10 mt-4 md:mt-8 justify-center">
        <div class="md:mt-16 lg:mt-24 z-10 mr-2"><img src="~@/assets/images/202207/babo-hot.png" class="object-contain"></div>
        <div class="md:mt-16 lg:mt-24 z-10"><img src="~@/assets/images/202207/pic-01.png" class="object-contain"></div>
        <div><img src="~@/assets/images/202207/master-title.png" class="object-contain"></div>
        <div class="md:mt-16 lg:mt-24 z-10"><img src="~@/assets/images/202207/pic-02.png" class="object-contain"></div>
        <div class="md:mt-16 lg:mt-24 z-10 ml-2"><img src="~@/assets/images/202207/babo-read.png" class="object-contain"></div>
      </div>
      <div class="flex max-w-6xl mx-auto -mt-1 md:-mt-16 lg:-mt-24 justify-center">
        <img src="~@/assets/images/202207/Program-all.png" class="object-contain">
      </div>
    </section>
    <section class="mos mb-6 px-2 pb-8">
      <div class="flex max-w-6xl mx-auto mb-6 cursor-pointer justify-center">
        <a class="hover-item block" @click="toTop(0)">
          <img src="~@/assets/images/202207/slide_bar-off_01.png" class="object-contain off">
          <img src="~@/assets/images/202207/slide_bar-on_01.png" class="object-contain on">
        </a>
        <a class="hover-item block" @click="toTop(1)">
          <img src="~@/assets/images/202207/slide_bar-off_02.png" class="object-contain off">
          <img src="~@/assets/images/202207/slide_bar-on_02.png" class="object-contain on">
        </a>
        <a class="hover-item block" @click="toTop(2)">
          <img src="~@/assets/images/202207/slide_bar-off_03.png" class="object-contain off">
          <img src="~@/assets/images/202207/slide_bar-on_03.png" class="object-contain on">
        </a>
        <a class="hover-item block" @click="toTop(3)">
          <img src="~@/assets/images/202207/slide_bar-off_04.png" class="object-contain off">
          <img src="~@/assets/images/202207/slide_bar-on_04.png" class="object-contain on">
        </a>
      </div>
      <div class="flex max-w-6xl mx-auto flex-wrap justify-center" id="jumo0">
        <div class="w-full">
          <img src="~@/assets/images/202207/title-MOS.png" class="object-contain mx-auto">
        </div>
      </div>
    </section>
    <section class="slogen pb-6 bg-white px-2">
      <div class="flex max-w-6xl mx-auto flex-wrap justify-center">
        <div class="w-full -mt-12 mb-6">
          <img src="~@/assets/images/202207/buger-photo.png" class="object-contain mx-auto">
        </div>
        <div class="w-full text-center max-w-4xl mx-auto">
          <h6 class="mb-2 text-lg text-purple-july">活動辦法：</h6>
          <p class="leading-loose">2022.7.1~2022.8.21於LiveABC官方網站及紙本雜誌訂購單購買商品，訂單成立後可參加「滿額加碼送摩斯早餐」活動，單筆訂單以一次為限，「摩斯漢堡早餐券」為LiveABC向Ticket Xpress即享券企業禮贈平台購買之票券，將於2022.9.30前統一以簡訊方式寄出。</p>
        </div>
        <div class="w-full py-8">
          <img src="~@/assets/images/202207/line-1.png" class="object-contain mx-auto">
        </div>
        <div class="w-full" id="jumo1">
          <img src="~@/assets/images/202207/price-down-title_1.png" class="object-contain mx-auto">
        </div>
        <div class="w-full flex items-center">
          <div class="w-1/5 hidden md:block">
            <img src="~@/assets/images/202207/pic-03.png" class="object-contain">
          </div>
          <div class="px-2 w-full md:w-3/5 flex flex-col justify-end items-center">
            <img src="~@/assets/images/202207/price-down-title_2.png" class="object-contain mb-4">
            <p class="leading-loose max-w-lg text-lg">
              <span>活動辦法：</span>
              2022.7.1~2022.9.30於LiveABC官方網站及紙本雜誌訂購單，完成「2022暑期降價」雜誌訂閱方案，訂單成立後即可參加「訂就抽現金8,888元」活動，１筆訂單可參與抽獎乙次（以訂單編號為主）。
            </p>
          </div>
          <div class="w-1/5 hidden md:block">
            <img src="~@/assets/images/202207/pic-04.png" class="object-contain">
          </div>
        </div>
      </div>
    </section>

    <!-- 雜誌介紹 -->
    <section class="magDatas bg-white px-2">
      <div class="flex max-w-6xl mx-auto flex-wrap justify-center">
        <div class="w-full">
          <img src="~@/assets/images/202207/magazine-titile.png" class="object-contain mx-auto">
        </div>
        <div class="flex flex-wrap w-full">
          <router-link :to="{ name: 'detail', params: { category: 'magazine', id: item.id } }" class="item w-1/2 md:w-1/4 p-2 md:p-4 cursor-pointer" v-for="(item, idx) in magData" :key="idx">

            <div class="item-inner bg-white rounded-3xl p-4 h-full flex flex-col justify-between" v-if="renderComponent">
              <div class="">
                <!-- <img src="@/assets/images/preset_item_small.png" class="w-full h-full object-contain block" v-if="!item.cover">
                <img v-lazy="item.cover" class="w-full h-full object-contain block" v-else> -->
                <!-- <div class="title p-1 rounded-lg xl:rounded-full mb-4">
                  <h6 class="text-white text-center text-base md:text-lg xl:text-2xl">{{ item.introduction }}</h6>
                </div> -->
                <div class="outer">
                  <div class="inner mx-auto border-0 absolute w-full h-full">
                    <img src="@/assets/images/preset_item_small.png" class="w-full h-full object-contain block"  v-if="!item.cover">
                    <img v-lazy="item.cover" class="w-full h-full object-contain block" v-else>
                  </div>
                </div>
              </div>
              <div class="p-1 rounded-lg xl:rounded-full my-2 lg:my-4 font-bold">
                <!-- <h6 class="text-center text-lg xl:text-2xl text-purple-july mb-1">ABC互動英語</h6> -->
                <h6 class="text-center text-lg xl:text-2xl text-purple-july">{{ item.showTitle }}</h6>
                <h6 class="text-center text-base md:text-lg mb-1">{{ item.introduction }}</h6>
                <h6 class="text-center text-base md:text-lg mb-1">{{ item.text }}</h6>
              </div>
              <div class="flex justify-center slogan">
                <a href=""><img src="~@/assets/images/202207/bt-01.png" class="object-contain mx-auto"></a>
                <!-- <p>15期特價1880</p> -->
              </div>
            </div>
          </router-link>
        </div>
        <div class="flex">
          <div class="pr-2 pt-3 md:pt-4">
            <img src="~@/assets/images/202207/title-4mg.png" class="object-contain">
          </div>
          <div class="flex-1 flex flex-wrap">

            <div v-for="(item, index) in sectionData1" :key="index" id="section1">
              <div class="flex flex-wrap mb-6">
                <router-link :to="{ name: 'detail', params: { category: 'book', id: child.id } }" class="item w-1/2 lg:w-1/5 cursor-pointer" v-for="(child, idx) in item.items" :key="idx">

                  <div class="item-inner bg-white p-3 md:p-4 h-full flex flex-col justify-between" v-if="renderComponent">
                    <div>
                      <div class="">
                        <img src="@/assets/images/preset_item_small.png" class="w-full h-full object-contain block" v-if="!child.cover">
                        <img v-lazy="child.cover" class="w-full h-full object-contain block" v-else>
                        <!-- <div class="title p-1 rounded-lg xl:rounded-full mb-4">
                          <h6 class="text-white text-center text-base md:text-lg xl:text-2xl">{{ item.introduction }}</h6>
                        </div> -->
                        <!-- <div class="outer mb-2">
                          <div class="inner mx-auto border-0 absolute w-full h-full">
                            <img src="@/assets/images/preset_item_small.png" class="w-full h-full object-contain block"  v-if="!child.cover">
                            <img v-lazy="child.cover" class="w-full h-full object-contain block" v-else>
                          </div>
                        </div> -->
                      </div>
                      <!-- <div class="outer mb-2">
                        <div class="inner mx-auto border-0 p-2 sm:p-3 md:p-4 absolute w-full h-full">
                          <img src="@/assets/images/preset_item_small.png" class="w-full h-full object-contain block" v-if="!child.cover">
                          <img v-lazy="child.cover" class="w-full h-full object-contain block" v-else>
                        </div>
                      </div> -->
                      <!-- <div class="p-1 mb-2">
                        <h6 class="text-center text-sm md:text-base font-medium">{{ child.introduction }}</h6>
                      </div> -->
                      <div class="mt-3">
                        <div>
                          <dealBookName :nameVal="child.name" v-if="child.name" class="text-center whitespace-pre-wrap" />
                        </div>
                      </div>
                    </div>

                    <div class="flex md:justify-center md:items-end mt-1 flex-wrap" v-if="child.name">
                      <!-- <p v-if="child.type === 'PACKAGE'" class="fixed_price line-through">原價:{{ child.fixed_price }}</p>
                      <p v-if="child.type === 'BOOK'"><span class="pricing">{{ child.display_discount }}</span>折</p> -->
                      <p>原價<span class="">{{ child.fixed_price }}元</span></p>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="w-full py-8">
          <img src="~@/assets/images/202207/line-1.png" class="object-contain mx-auto">
        </div>
      </div>
    </section>
    <!-- JPN -->
    <section class="JPN bg-white px-2">
      <div class="flex max-w-6xl mx-auto flex-wrap justify-center">
        <a class="w-full mb-4 block" href="https://store.liveabc.com/magazine/detail/7577" target="_blank">
          <img src="~@/assets/images/202207/magazine-japan-title.png" class="object-contain mx-auto">
        </a>
        <div class="flex">
          <div class="pr-2 pt-3 md:pt-4">
            <img src="~@/assets/images/202207/title-4mg.png" class="object-contain">
          </div>
          <div class="flex-1 flex flex-wrap">

            <div v-for="(item, index) in sectionData2" :key="index" id="section2">
              <div class="flex flex-wrap mb-6">
                <router-link :to="{ name: 'detail', params: { category: 'book', id: child.id } }" class="item w-1/2 lg:w-1/5 cursor-pointer" v-for="(child, idx) in item.items" :key="idx">

                  <div class="item-inner bg-white p-3 md:p-4 h-full flex flex-col justify-between" v-if="renderComponent">
                    <div>
                      <div class="">
                        <img src="@/assets/images/preset_item_small.png" class="w-full h-full object-contain block"  v-if="!child.cover">
                        <img v-lazy="child.cover" class="w-full h-full object-contain block" v-else>
                        <!-- <div class="title p-1 rounded-lg xl:rounded-full mb-4">
                          <h6 class="text-white text-center text-base md:text-lg xl:text-2xl">{{ item.introduction }}</h6>
                        </div> -->
                        <!-- <div class="outer mb-2">
                          <div class="inner mx-auto border-0 absolute w-full h-full">
                            <img src="@/assets/images/preset_item_small.png" class="w-full h-full object-contain block"  v-if="!item.cover">
                            <img v-lazy="item.cover" class="w-full h-full object-contain block" v-else>
                          </div>
                        </div> -->
                      </div>
                      <!-- <div class="outer mb-2">
                        <div class="inner mx-auto border-0 p-2 sm:p-3 md:p-4 absolute w-full h-full">
                          <img src="@/assets/images/preset_item_small.png" class="w-full h-full object-contain block" v-if="!child.cover">
                          <img v-lazy="child.cover" class="w-full h-full object-contain block" v-else>
                        </div>
                      </div> -->
                      <!-- <div class="p-1 mb-2">
                        <h6 class="text-center text-sm md:text-base font-medium">{{ child.introduction }}</h6>
                      </div> -->
                      <div class="mt-3">
                        <div>
                          <dealBookName :nameVal="child.name" v-if="child.name" class="text-center whitespace-pre-wrap" />
                        </div>
                      </div>
                    </div>

                    <div class="flex md:justify-center md:items-end mt-1 flex-wrap" v-if="child.name">
                      <!-- <p v-if="child.type === 'PACKAGE'" class="fixed_price line-through">原價:{{ child.fixed_price }}</p>
                      <p v-if="child.type === 'BOOK'"><span class="pricing">{{ child.display_discount }}</span>折</p> -->
                      <p>原價<span class="">{{ child.fixed_price }}元</span></p>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- HIW -->
    <section class="HIW bg-white px-2">
      <div class="w-full py-8">
        <img src="~@/assets/images/202207/line-1.png" class="object-contain mx-auto">
      </div>
      <div class="flex max-w-6xl mx-auto flex-wrap justify-center">
        <a class="w-full mb-4 block" href="https://store.liveabc.com/magazine/detail/7586" target="_blank">
          <img src="~@/assets/images/202207/magazine-hiw-title.png" class="object-contain mx-auto">
        </a>
        <div class="flex">
          <div class="pr-2 pt-3 md:pt-4">
            <img src="~@/assets/images/202207/S-title-hiw.png" class="object-contain">
          </div>
          <div class="flex-1 flex flex-wrap">

            <div v-for="(item, index) in sectionData3" :key="index" id="section3">
              <div class="flex flex-wrap mb-6">
                <router-link :to="{ name: 'detail', params: { category: 'book', id: child.id } }" class="item w-1/2 lg:w-1/4 cursor-pointer" v-for="(child, idx) in item.items" :key="idx">

                  <div class="item-inner bg-white p-3 md:p-4 h-full flex flex-col justify-between" v-if="renderComponent">
                    <div>
                      <div class="">
                        <img src="@/assets/images/preset_item_small.png" class="w-full h-full object-contain block"  v-if="!child.cover">
                        <img v-lazy="child.cover" class="w-full h-full object-contain block" v-else>
                        <!-- <div class="title p-1 rounded-lg xl:rounded-full mb-4">
                          <h6 class="text-white text-center text-base md:text-lg xl:text-2xl">{{ item.introduction }}</h6>
                        </div> -->
                        <!-- <div class="outer mb-2">
                          <div class="inner mx-auto border-0 absolute w-full h-full">
                            <img src="@/assets/images/preset_item_small.png" class="w-full h-full object-contain block"  v-if="!child.cover">
                            <img v-lazy="child.cover" class="w-full h-full object-contain block" v-else>
                          </div>
                        </div> -->
                      </div>
                      <!-- <div class="outer mb-2">
                        <div class="inner mx-auto border-0 p-2 sm:p-3 md:p-4 absolute w-full h-full">
                          <img src="@/assets/images/preset_item_small.png" class="w-full h-full object-contain block" v-if="!child.cover">
                          <img v-lazy="child.cover" class="w-full h-full object-contain block" v-else>
                        </div>
                      </div> -->
                      <!-- <div class="p-1 mb-2">
                        <h6 class="text-center text-sm md:text-base font-medium">{{ child.introduction }}</h6>
                      </div> -->
                      <div class="mt-3">
                        <div>
                          <dealBookName :nameVal="child.name" v-if="child.name" class="text-center whitespace-pre-wrap" />
                        </div>
                      </div>
                    </div>

                    <div class="flex md:justify-center md:items-end mt-1 flex-wrap" v-if="child.name">
                      <!-- <p v-if="child.type === 'PACKAGE'" class="fixed_price line-through">原價:{{ child.fixed_price }}</p>
                      <p v-if="child.type === 'BOOK'"><span class="pricing">{{ child.display_discount }}</span>折</p> -->
                      <p>原價<span class="">{{ child.fixed_price }}元</span></p>
                    </div>
                  </div>
                </router-link>
                <div class="item w-1/2 lg:w-1/4 p-3 md:p-4">
                  <img src="~@/assets/images/202207/pic-05.png" class="object-contain">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- 充實語言力 -->
    <section class="language py-12 px-2" id="jumo2">
      <div class="flex max-w-6xl mx-auto flex-wrap justify-center">
        <div class="w-full mb-6">
          <img src="~@/assets/images/202207/book-title.png" class="object-contain mx-auto">
        </div>
        <a class="w-full block mb-6 cursor-pointer" href="https://store.liveabc.com/products/book/sale?tag=162" target="_blank">
          <img src="~@/assets/images/202207/more-book-bt.png" class="object-contain mx-auto">
        </a>

        <div class="flex flex-wrap ">

          <div v-for="(item, index) in sectionData4" :key="index" id="section4">
            <div class="flex flex-wrap mb-6">
              <router-link :to="{ name: 'detail', params: { category: 'book', id: child.id } }" class="item w-1/2 lg:w-1/4 cursor-pointer p-3" v-for="(child, idx) in item.items" :key="idx">

                <div class="item-inner bg-white p-3 md:p-6 h-full flex flex-col justify-between shadow-lg shadow-gray-900 rounded-lg" v-if="renderComponent">
                  <div>
                    <div class="outer mb-2">
                      <div class="inner mx-auto border-0 p-2 sm:p-3 md:p-3 absolute w-full h-full">
                        <img src="@/assets/images/preset_item_small.png" class="w-full h-full object-contain block" v-if="!child.cover">
                        <img v-lazy="child.cover" class="w-full h-full object-contain block" v-else>
                      </div>
                    </div>
                    <div class="p-1 mb-2 border-t-4 border-dotted border-purple-600 pt-2">
                      <h6 class="text-purple-july text-center text-sm md:text-base font-bold">{{ child.introduction }}</h6>
                    </div>
                    <div>
                      <div>
                        <dealBookName :nameVal="child.name" v-if="child.name" class="text-center whitespace-pre-wrap" />
                      </div>
                    </div>
                  </div>

                  <div class="flex md:justify-center md:items-end mt-3 flex-wrap" v-if="child.name">
                    <!-- <p v-if="child.type === 'PACKAGE'" class="fixed_price line-through">原價:{{ child.fixed_price }}</p> -->
                    <!-- <p v-if="child.type === 'BOOK'"><span class="pricing">{{ child.display_discount }}</span>折</p> -->
                    <!-- <p>特價<span class="pricing">{{ child.pricing }}元</span></p> -->
                    <p>原價<span class="">{{ child.fixed_price }}元</span></p>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>

      </div>
    </section>
    <!-- 數位學習最超值 -->
    <section class="digital py-12 px-2" id="jumo3">
      <div class="w-full mb-6">
        <img src="~@/assets/images/202207/digtal-title.png" class="object-contain mx-auto">
      </div>
      <a class="w-full block mb-6 cursor-pointer" href="https://store.liveabc.com/products/book/sale?tag=126" target="_blank">
        <img src="~@/assets/images/202207/more-digital-bt.png" class="object-contain mx-auto">
      </a>
      <!-- <div class="flex max-w-6xl mx-auto flex-wrap justify-center">
        <div class="w-full">
          <img src="~@/assets/images/202207/magazine-titile.png" class="object-contain">
        </div>
      </div> -->
      <div class="bookList bookList3 bg-white py-2 px-2 relative max-w-6xl mx-auto rounded-lg">
        <!-- <a class="title-label mx-auto inline-block">
          <img src="~@/assets/images/202205/C3/c3-tit2.png" class="object-contain">
        </a> -->
        <div class="flex flex-wrap">

          <div v-for="(item, index) in sectionData5" :key="index" id="section5">
            <div class="flex flex-wrap mb-6">
              <router-link :to="{ name: 'detail', params: { category: 'book', id: child.id } }" class="item w-1/2 lg:w-1/4 cursor-pointer border-dotted border-indigo-600" :class="{ 'border-b-8': (idx === 0 || idx === 1 || idx === 2 || idx === 3 || idx === 4 || idx === 5), 'lg:border-b-0': (idx === 4 || idx === 5), 'lg:border-b-8': (idx === 0 || idx === 1 || idx === 2 || idx === 3)}" v-for="(child, idx) in item.items" :key="idx">

                <div class="item-inner bg-white p-4 h-full flex flex-col justify-between" v-if="renderComponent"
                  >
                  <div class="p-3 border-dotted border-indigo-600 item-inner bg-white h-full flex flex-col justify-between"
                    :class="{ 'border-r-8': (idx === 0 || idx === 2 || idx === 4 || idx === 6), 'lg:border-r-8': (idx === 0 || idx === 1 || idx === 2 || idx === 4 || idx === 5 || idx === 6), 'lg:border-b-0': (idx === 4 || idx === 5)}">
                    <div>
                      <div class="outer mb-2">
                        <div class="inner mx-auto border-0 p-2 sm:p-3 md:p-4 absolute w-full h-full">
                          <img src="@/assets/images/preset_item_small.png" class="w-full h-full object-contain block" v-if="!child.cover">
                          <img v-lazy="child.cover" class="w-full h-full object-contain block" v-else>
                        </div>
                      </div>
                      <div class="p-1 mb-2">
                        <h6 class="text-purple-july text-center text-sm md:text-base font-bold">{{ child.introduction }}</h6>
                      </div>
                      <div>
                        <div>
                          <dealBookName :nameVal="child.name" v-if="child.name" class="text-center whitespace-pre-wrap" />
                        </div>
                      </div>
                    </div>

                    <div class="flex md:justify-center md:items-end mt-3 flex-wrap" v-if="child.name">
                      <p class="fixed_price">原價:{{ child.fixed_price }}</p>
                      <!-- <p v-if="child.type === 'BOOK'"><span class="pricing">{{ child.display_discount }}</span>折</p>
                      <p>特價:<span class="pricing">{{ child.pricing }}</span></p> -->
                    </div>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- 注意事項 -->
    <section class="note flex w-full py-8 px-2">
      <div class="py-3 px-10 leading-loose text-lg tracking-wider max-w-6xl mx-auto w-full font-medium">
        <p>注意事項</p>
        <ul class="list-decimal list-outside">
          <li>活動期間產生之訂單取消、退貨、交易失敗等條件，將失去參與本活動之資格，不予另行通知。</li>
          <li>「訂就抽現金8,888元」將於2022.10.20抽出乙名得主，公告於LiveABC官方網站及官方臉書粉絲團。</li>
          <li>中華民國稅法規定，中獎贈品或獎金原價超過市價新台幣1,000元，年度報稅時須計入個人所得，故中獎人於領獎後、所得稅徵收前，將會收到本公司所發出之扣繳憑證。</li>
          <li>本活動之抽獎贈品不得轉換、轉讓他人。</li>
          <li>如提供獎項因故無法取得，本公司保留替換其他等值獎項及變更、修改本活動之權利，並將最新變更後內容公布於官網活動頁面，不再個別提醒/通知客戶本活動內容之變更。</li>
          <li>詳細活動內容以LiveABC官網發布為主。本公司保留活動修改、變更之權利。</li>
        </ul>
      </div>
    </section>
  </div>
</template>
<script>
import axios from 'axios'
import jump from 'jump.js'
import dealBookName from '@/components/modules/dealBookName'
export default {
  name: 'July2022',
  metaInfo () {
    return {
      title: 'LiveABC夏日讀書季 炎炎夏日讀書正好',
      titleTemplate: null
    }
  },
  components: {
    dealBookName
  },
  data () {
    return {
      linksOfftop: 0,
      isFixed: false,
      renderComponent: true,
      magData: [
        { id: 7600, showTitle: 'ABC互動英語', introduction: '初級 | 基礎 | 活用', text: '打好英語基礎的最佳選擇！', url: 'https://store.liveabc.com/magazine/detail/7555' },
        { id: 7616, showTitle: 'Live互動英語', introduction: '中級 | 生活 | 實用', text: '日常生活實用英語輕鬆學！', url: 'https://store.liveabc.com/magazine/detail/7556' },
        { id: 7608, showTitle: 'ALL+互動英語', introduction: '中高級 | 進階 | 應用', text: '閱讀寫作訓練豐富又多元！', url: 'https://store.liveabc.com/magazine/detail/7557' },
        { id: 7592, showTitle: 'CNN互動英語', introduction: '新聞 | 時事 | 新知', text: '官方授權的專業新聞素材！', url: 'https://store.liveabc.com/magazine/detail/7558' }
        // { id: 7788, introduction: '初級/生活/實用', text: '6期特價990' },
        // { id: 7790, introduction: '圖解/百科/符合108課綱', text: '6期特價990' }
      ],
      // 訂就送經典好書10本任你選
      sectionData1: [
        {
          link: 'https://store.liveabc.com/products/book?type=BOOK&category=110',
          items: [
            { id: 1771, introduction: '英檢初級必背' },
            { id: 6238, introduction: '手繪英語極短句' },
            { id: 5543, introduction: '臨時一定要會的英語怎麼說(口袋書)' },
            { id: 7434, introduction: '聽懂CNN主播最常用的英語關鍵字(口袋書)' },
            { id: 6521, introduction: '生活百分百單字大全(口袋書)' },
            { id: 4423, introduction: '圖解新多益單字王(口袋書)' },
            { id: 4418, introduction: '解構英文句型王(口袋書)' },
            { id: 7002, introduction: '老外都想幫你按個讚!網路+社群英語流行語(口袋書)' },
            { id: 7161, introduction: '外師最推薦的歐美經典英語故事集(口袋書)' },
            { id: 5450, introduction: 'CNN實況片語選 (口袋書)' }
          ]
        }
      ],
      // JP
      sectionData2: [
        {
          link: 'https://store.liveabc.com/magazine/detail/7559',
          items: [
            { id: 5078, introduction: '聽懂新聞聊天不缺話題' },
            { id: 5094, introduction: '閱讀是英語學習的基礎' },
            { id: 5934, introduction: '網路社群用語快學起來' },
            { id: 6237, introduction: '別讓片語限制了英語程度' },
            { id: 7403, introduction: '會唸才能派得上用場' },
            { id: 6874, introduction: '27篇經典作品值得收藏' },
            { id: 5504, introduction: '老外都在說的英語短句' },
            { id: 6263, introduction: '500個必學口語用法' },
            { id: 7732, introduction: '了解慣用語掌握使用情境' },
            { id: 5372, introduction: '圖解學日語好輕鬆' }
          ]
        }
      ],
      // HIW
      sectionData3: [
        {
          link: 'https://store.liveabc.com/magazine/detail/7586',
          items: [
            { id: 7355, introduction: '聽懂新聞聊天不缺話題' },
            { id: 7134, introduction: '閱讀是英語學習的基礎' },
            { id: 5967, introduction: '網路社群用語快學起來' },
            { id: 5977, introduction: '別讓片語限制了英語程度' },
            { id: 6189, introduction: '會唸才能派得上用場' },
            { id: 6007, introduction: '27篇經典作品值得收藏' },
            { id: 7582, introduction: '老外都在說的英語短句' }
          ]
        }
      ],
      // 充實語言力
      sectionData4: [
        {
          link: 'https://store.liveabc.com/products/book?type=BOOK&category=110',
          items: [
            { id: 7849, introduction: '跟著CNN主播最實用單字' },
            { id: 7801, introduction: '用圖像記憶學單字有效率' },
            { id: 7799, introduction: '專攻學測兩大題型就靠他' },
            { id: 7694, introduction: '讓佩佩豬當你的英語小老師' },
            { id: 7647, introduction: '上班族必備職場語言硬實力' },
            { id: 7496, introduction: '一網打盡各種吃和玩樂英語' },
            { id: 6356, introduction: '出發日本前必備精彩主題' },
            { id: 7456, introduction: '拚金色證書必備工具書' }
          ]
        }
      ],
      sectionData5: [
        {
          link: 'https://store.liveabc.com/products/book?type=BOOK&category=110',
          items: [
            { id: 7505, introduction: '第一本西班牙語入門工具書' },
            { id: 7454, introduction: '一次通過全民英檢初級必備' },
            { id: 7375, introduction: '加薪轉職前先做好準備' },
            { id: 7442, introduction: '看懂新聞英語要掌握關鍵字彙' },
            { id: 7292, introduction: '第一本西班牙語入門工具書' },
            { id: 6820, introduction: '一次通過全民英檢初級必備' },
            { id: 6831, introduction: '英語實力從小開始培養' },
            { id: 6813, introduction: '跟著佩佩豬一起遊戲中學習' }
          ]
        }
      ],
      pageSize: 20
    }
  },
  async mounted () {
    await this.getEvent()
  },
  destroyed () {
  },
  methods: {
    async getEvent () {
      let self = this
      for (let i = 0; i < self.sectionData1.length; i++) {
        await self.getData(i, self.sectionData1[i].items)
      }
      for (let i = 0; i < self.sectionData2.length; i++) {
        await self.getData(i, self.sectionData2[i].items)
      }
      for (let i = 0; i < self.sectionData3.length; i++) {
        await self.getData(i, self.sectionData3[i].items)
      }
      for (let i = 0; i < self.sectionData4.length; i++) {
        await self.getData(i, self.sectionData4[i].items)
      }
      for (let i = 0; i < self.sectionData5.length; i++) {
        await self.getData(i, self.sectionData5[i].items)
      }
      self.getData2(self.magData)
      // self.getData2(self.presentsData)
      // self.getData2(self.presentsData2)
    },
    getData (idx, itemData) {
      let self = this
      let pathArr = []
      for (let i = 0; i < itemData.length; i++) {
        pathArr.push(itemData[i].id)
      }

      axios.get(`/products?list=${pathArr.toString()}&pageSize=${self.pageSize}`)
        .then((response) => {
          response.data.data.map(item1 => {
            itemData.map(item2 => {
              if (item1.id === item2.id) {
                return Object.assign(item2, item1)
              }
            })
          })
        })
        .then(() => {
          self.forceRerender()
        })
    },
    getData2 (itemData) {
      let self = this
      let pathArr = []
      for (let i = 0; i < itemData.length; i++) {
        pathArr.push(itemData[i].id)
      }
      axios.get(`/products?list=${pathArr.toString()}&pageSize=${self.pageSize}`)
        .then((response) => {
          response.data.data.map(item1 => {
            itemData.map(item2 => {
              if (item1.id === item2.id) {
                return Object.assign(item2, item1)
              }
            })
          })
        })
        .then(() => {
          self.forceRerender()
        })
    },

    forceRerender () {
      this.renderComponent = false
      this.$nextTick(() => {
        this.renderComponent = true
      })
    },
    toTop (n) {
      jump(`#jumo${n}`, {
        duration: 500,
        offset: 0
      })
    },
    replace (name) {
      return name.replace(' ', '<br/>')
    }
  }
}
</script>
<style lang="scss" scoped>
.rounded-3xl {
  border-radius: 1.5rem;
}
.pricing {
  color: #ff0000;
}
.border-blue {
  border-color: #b9bec2;
}
.text-purple-july {
  color: #5a46d7;
}
.fixed-btn {
  top: 50%;
  transform: translateY(-50%);
  right: 0%;
  transition: 0.3s;
}
.hover-item {
  .on {
    display: none;
  }
  &:hover {
    .off {
      display: none;
    }
    .on {
      display: block;
    }
  }
}
.outer {
  position: relative;
  width: 100%;
  background:white;
  display: block;
  &:after {
    content: "";
    display: block;
    padding-Bottom: 100%;
  }
  .inner {
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
.title {
  background-color: #ff781f;
  @media (max-width: 1024px) {
    min-height: 56px;
  }
  @media (max-width: 768px) {
    min-height: 50px;
  }
}
.fixed_price {
  text-decoration-color: red;
}
.july2022 {
  color: #333333;
  // background-color: #F3BBAB;
  background-image: url('~@/assets/images/202207/BG-Y.png');
  background-size: contain;
  .header {
    background: #5A47D7;
  }
  .planTables {

  }
  .language {
    background-image: url('~@/assets/images/202207/BG-P.png');
    background-size: contain;
  }
  .section3 {
    background-color: #ffeb92;
  }
  .section4 {
    background-color: #fed977;
  }
  .section5 {
    background-color: #ffeb92;
  }
  .digital {
    background: #362873;
  }
  .bookList {
    .title-label {
      width: 100%;
      position: absolute;
      top: 0;
      left: 50%;
      transform: translate(-50%, -50%);
      // width: 100%;
      // margin-top: -12em;
      @media (max-width: 768px) {
        width: 80%;
      }
      img {
        margin-left: auto !important;
        margin-right: auto !important;
        height: 70px;
        @media (max-width: 768px) {
          height: 60px;
        }
      }
    }
    .item {
      .hot {
        position: absolute;
        left: -4%;
        top: -4%;
        width: 85px;
        @media (max-width: 768px) {
          width: 85px;
          left: -5%;
          top: -5%;
          width: 80px;
        }
        // transform: translate(50%, 50%);
      }
      .item-inner {
        // min-height: 360px;
        // transition: .3s;
        // &:hover {
        //   transform: translateY(-15px);
        // }
      }
    }
    .more-btn {
      display: inline-block;
      position: absolute;
      // width: 100%;
      bottom: 0;
      left: 50%;
      transform: translate(-50%, 50%);
      // width: 100%;
      // margin-top: -12em;
      @media (max-width: 768px) {
        width: 80%;
      }
      img {
        margin: 0 auto;
      }
      // bottom: 0;
      // left: 50%;
      // transform: translate(-50%, -50%);
    }
  }
  .note {
    background: #362873 !important;
    color: #ffffff;
  }
  background-attachment: fixed;
}
</style>
